/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PortalRouteImport } from './routes/portal'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as SetPasswordRouteImport } from './routes/set-password'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppOrdersRouteImport } from './routes/_app/orders'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppSupportRouteImport } from './routes/_app/support'
import { Route as AppCustomersIndexRouteImport } from './routes/_app/customers/index'
import { Route as AppCustomersCustomerIdRouteImport } from './routes/_app/customers/$customerId'
import { Route as AppOutletsIndexRouteImport } from './routes/_app/outlets/index'
import { Route as AppOutletsOutletIdRouteImport } from './routes/_app/outlets/$outletId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalRoute = PortalRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const SetPasswordRoute = SetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersRoute = AppOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppSupportRoute = AppSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersIndexRoute = AppCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersCustomerIdRoute = AppCustomersCustomerIdRouteImport.update({
  id: '/customers/$customerId',
  path: '/customers/$customerId',
  getParentRoute: () => AppRoute,
} as any)
const AppOutletsIndexRoute = AppOutletsIndexRouteImport.update({
  id: '/outlets/',
  path: '/outlets/',
  getParentRoute: () => AppRoute,
} as any)
const AppOutletsOutletIdRoute = AppOutletsOutletIdRouteImport.update({
  id: '/outlets/$outletId',
  path: '/outlets/$outletId',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/portal': typeof PortalRoute
  '/register': typeof RegisterRoute
  '/set-password': typeof SetPasswordRoute
  '/signup': typeof SignupRoute
  '/orders': typeof AppOrdersRoute
  '/settings': typeof AppSettingsRoute
  '/support': typeof AppSupportRoute
  '/customers/$customerId': typeof AppCustomersCustomerIdRoute
  '/outlets/$outletId': typeof AppOutletsOutletIdRoute
  '/customers/': typeof AppCustomersIndexRoute
  '/outlets/': typeof AppOutletsIndexRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/portal': typeof PortalRoute
  '/register': typeof RegisterRoute
  '/set-password': typeof SetPasswordRoute
  '/signup': typeof SignupRoute
  '/orders': typeof AppOrdersRoute
  '/settings': typeof AppSettingsRoute
  '/support': typeof AppSupportRoute
  '/': typeof AppIndexRoute
  '/customers/$customerId': typeof AppCustomersCustomerIdRoute
  '/outlets/$outletId': typeof AppOutletsOutletIdRoute
  '/customers': typeof AppCustomersIndexRoute
  '/outlets': typeof AppOutletsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/portal': typeof PortalRoute
  '/register': typeof RegisterRoute
  '/set-password': typeof SetPasswordRoute
  '/signup': typeof SignupRoute
  '/_app/orders': typeof AppOrdersRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/support': typeof AppSupportRoute
  '/_app/': typeof AppIndexRoute
  '/_app/customers/$customerId': typeof AppCustomersCustomerIdRoute
  '/_app/outlets/$outletId': typeof AppOutletsOutletIdRoute
  '/_app/customers/': typeof AppCustomersIndexRoute
  '/_app/outlets/': typeof AppOutletsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/portal'
    | '/register'
    | '/set-password'
    | '/signup'
    | '/orders'
    | '/settings'
    | '/support'
    | '/customers/$customerId'
    | '/outlets/$outletId'
    | '/customers/'
    | '/outlets/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/portal'
    | '/register'
    | '/set-password'
    | '/signup'
    | '/orders'
    | '/settings'
    | '/support'
    | '/'
    | '/customers/$customerId'
    | '/outlets/$outletId'
    | '/customers'
    | '/outlets'
  id:
    | '__root__'
    | '/_app'
    | '/forgot-password'
    | '/login'
    | '/portal'
    | '/register'
    | '/set-password'
    | '/signup'
    | '/_app/orders'
    | '/_app/settings'
    | '/_app/support'
    | '/_app/'
    | '/_app/customers/$customerId'
    | '/_app/outlets/$outletId'
    | '/_app/customers/'
    | '/_app/outlets/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  PortalRoute: typeof PortalRoute
  RegisterRoute: typeof RegisterRoute
  SetPasswordRoute: typeof SetPasswordRoute
  SignupRoute: typeof SignupRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal': {
      id: '/portal'
      path: '/portal'
      fullPath: '/portal'
      preLoaderRoute: typeof PortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/set-password': {
      id: '/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof SetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders': {
      id: '/_app/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AppOrdersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/support': {
      id: '/_app/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AppSupportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/': {
      id: '/_app/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AppCustomersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/$customerId': {
      id: '/_app/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof AppCustomersCustomerIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/outlets/': {
      id: '/_app/outlets/'
      path: '/outlets'
      fullPath: '/outlets/'
      preLoaderRoute: typeof AppOutletsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/outlets/$outletId': {
      id: '/_app/outlets/$outletId'
      path: '/outlets/$outletId'
      fullPath: '/outlets/$outletId'
      preLoaderRoute: typeof AppOutletsOutletIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppOrdersRoute: typeof AppOrdersRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppSupportRoute: typeof AppSupportRoute
  AppIndexRoute: typeof AppIndexRoute
  AppCustomersCustomerIdRoute: typeof AppCustomersCustomerIdRoute
  AppOutletsOutletIdRoute: typeof AppOutletsOutletIdRoute
  AppCustomersIndexRoute: typeof AppCustomersIndexRoute
  AppOutletsIndexRoute: typeof AppOutletsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppOrdersRoute: AppOrdersRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppSupportRoute: AppSupportRoute,
  AppIndexRoute: AppIndexRoute,
  AppCustomersCustomerIdRoute: AppCustomersCustomerIdRoute,
  AppOutletsOutletIdRoute: AppOutletsOutletIdRoute,
  AppCustomersIndexRoute: AppCustomersIndexRoute,
  AppOutletsIndexRoute: AppOutletsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  PortalRoute: PortalRoute,
  RegisterRoute: RegisterRoute,
  SetPasswordRoute: SetPasswordRoute,
  SignupRoute: SignupRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
